module.exports = __webpack_public_path__ + "media/images/icons/logoBI-iniciosesion-mobile-43320740202b43ccffb05ce520ff6ed5.svg";